var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q;
import { IDENTIFIERS } from '../../types/Identifiers';
import { TAG_TYPES } from '../../types/TagTypes';
import PROPS from '../../types/Props';
export var STORES_PRODUCT = {
    tags: [
        {
            type: TAG_TYPES.TITLE,
            children: '{{product.name}} | {{site.name}}',
        },
        {
            type: TAG_TYPES.META,
            props: (_a = {},
                _a[PROPS.NAME] = 'description',
                _a[PROPS.CONTENT] = "{{product.description}}",
                _a),
        },
        {
            type: TAG_TYPES.META,
            props: (_b = {},
                _b[PROPS.PROPERTY] = 'og:title',
                _b[PROPS.CONTENT] = "{{@" + IDENTIFIERS.TITLE + "}}",
                _b),
        },
        {
            type: TAG_TYPES.META,
            props: (_c = {},
                _c[PROPS.PROPERTY] = 'og:description',
                _c[PROPS.CONTENT] = "{{@" + IDENTIFIERS.DESCRIPTION + "}}",
                _c),
        },
        {
            type: TAG_TYPES.META,
            props: (_d = {},
                _d[PROPS.PROPERTY] = 'og:url',
                _d[PROPS.CONTENT] = '{{product.url}}',
                _d),
        },
        {
            type: TAG_TYPES.META,
            props: (_e = {},
                _e[PROPS.PROPERTY] = 'og:site_name',
                _e[PROPS.CONTENT] = '{{site.name}}',
                _e),
        },
        {
            type: TAG_TYPES.META,
            props: (_f = {},
                _f[PROPS.PROPERTY] = 'og:type',
                _f[PROPS.CONTENT] = 'product',
                _f),
        },
        {
            type: TAG_TYPES.META,
            props: (_g = {},
                _g[PROPS.NAME] = 'robots',
                _g[PROPS.CONTENT] = 'index',
                _g),
        },
        {
            type: TAG_TYPES.LINK,
            props: (_h = {},
                _h[PROPS.REL] = 'canonical',
                _h[PROPS.HREF] = '{{product.url}}',
                _h),
        },
        {
            type: TAG_TYPES.META,
            props: (_j = {},
                _j[PROPS.PROPERTY] = 'product:price:amount',
                _j[PROPS.CONTENT] = '{{product.price}}',
                _j),
        },
        {
            type: TAG_TYPES.META,
            props: (_k = {},
                _k[PROPS.PROPERTY] = 'product:price:currency',
                _k[PROPS.CONTENT] = '{{product.currency}}',
                _k),
        },
        {
            type: TAG_TYPES.META,
            props: (_l = {},
                _l[PROPS.PROPERTY] = 'og:availability',
                _l[PROPS.CONTENT] = '{{product.availability.metaTag}}',
                _l),
        },
        {
            type: TAG_TYPES.META,
            props: (_m = {},
                _m[PROPS.PROPERTY] = 'og:image',
                _m[PROPS.CONTENT] = '{{product.image.url}}',
                _m),
        },
        {
            type: TAG_TYPES.META,
            props: (_o = {},
                _o[PROPS.PROPERTY] = 'og:image:width',
                _o[PROPS.CONTENT] = '{{product.image.width}}',
                _o),
        },
        {
            type: TAG_TYPES.META,
            props: (_p = {},
                _p[PROPS.PROPERTY] = 'og:image:height',
                _p[PROPS.CONTENT] = '{{product.image.height}}',
                _p),
        },
        {
            type: TAG_TYPES.SCRIPT,
            props: (_q = {},
                _q[PROPS.TYPE] = 'application/ld+json',
                _q),
            children: "{\n        \"@context\": \"https://schema.org/\",\n        \"@type\": \"Product\",\n        \"name\": \"{{product.name}}\",\n        \"description\": \"{{product.description}}\",\n        \"sku\": \"{{product.sku}}\",\n        \"brand\": {\n          \"@type\": \"Thing\",\n          \"name\": \"{{site.business.name}}\"\n        },\n        \"image\": {\n          \"@type\": \"ImageObject\",\n          \"height\": \"{{product.image.height}}\",\n          \"width\": \"{{product.image.width}}\",\n          \"contentUrl\": \"{{product.image.url}}\",\n          \"representativeOfPage\": true,\n          \"name\": \"{{product.image.alt}}\",\n          \"thumbnail\": {\n            \"@type\": \"ImageObject\",\n            \"height\": \"{{product.thumbnail.height}}\",\n            \"width\": \"{{product.thumbnail.width}}\",\n            \"contentUrl\": \"{{product.thumbnail.url}}\",\n            \"name\": \"{{product.thumbnail.alt}}\"\n          }\n        },\n        \"Offers\": {\n          \"@type\": \"Offer\",\n          \"url\": \"{{product.url}}\",\n          \"priceCurrency\": \"{{product.currency}}\",\n          \"price\": \"{{product.price}}\",\n          \"Availability\": \"{{product.availability.schema}}\",\n          \"seller\": {\n            \"@type\": \"Organization\",\n            \"name\": \"{{site.business.name}}\",\n            \"sameAs\": \"{{site.url}}\"\n          }\n        }\n      }",
        },
    ],
};
